import { format, toDate } from 'date-fns';
import { DateFormat } from 'src/constants/dateTimeFormatOption';

export const transformDateHelper = (
  date: string | Date | null | undefined,
  dateFormat: string = DateFormat.MONTH_DAY_YEAR,
): string => (date ? format(toDate(new Date(date)), dateFormat) : '');
